import VibeQuizModal from './VibeQuizModal'

export default VibeQuizModal
